module.exports = __webpack_public_path__ + "img/saizi2_QX.2b5e74f5.png";